// START GENAI@GHCOPILOT
import 'orch-communicator/store/watchers';
import checkout from 'orch-communicator/external/checkout';
import getCards from 'orch-communicator/external/get-cards';
import initialize from 'orch-communicator/external/initialize';
import initiateIdentityValidation from 'orch-communicator/external/initiate-identity-validation';
import unbindAppInstance from 'orch-communicator/external/unbind-app-instance';
import identityLookup from 'orch-communicator/internal/identity-lookup';
import loadPartnerNetworks from 'orch-communicator/internal/load-partner-networks';
import pushEvents from 'vsb-sdk/api/push-events';
import { getState, saveSdksReady } from './store';
// END GENAI@GHCOPILOT

/**
 * Fired after orch_communicator iframe postMessages VSB_GLOBALS
 * Globals are applied to store data objects and are ready for INO partner
 * SDK load.
 */
//START GENAI@GHCOPILOT
const handleGlobalsReady = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    // TODO: Optimize partner network loading logic
    let sdksReady = false;
    loadPartnerNetworks()
      .then(() => {
        // eslint-disable-next-line
        console.log('<<<<<<<< LOADPARTERNETWORKS DONE');
        saveSdksReady();
        sdksReady = getState().sdksReady;
      })
      .catch(error => {
        // eslint-disable-next-line
        console.error('Failed to load INO SRC SDKs:', error);
        reject(error);
      });

    const timeout = 10;
    let maxtimeout = 5000;
    // eslint-disable-next-line
    const waitReady = (event: any) => {
      if (sdksReady) {
        // eslint-disable-next-line
        console.info('>>>>>>>>> SDKs are ready');
        // initialize(event.data);
        resolve();
      } else {
        maxtimeout -= timeout;

        if (maxtimeout > 0) {
          setTimeout(() => {
            waitReady(event);
          }, timeout);
        } else {
          reject(new Error('Timeout waiting for SDKs to load'));
        }
      }
    };

    // Start the waitReady process
    waitReady({});
  });
};
//END GENAI@GHCOPILOT

const namespace = 'VSDK';
//eslint-disable-next-line
window[namespace] = Object.assign({}, window[namespace], {
  checkout,
  //completeIdentityValidation,
  getCards,
  idLookup: identityLookup,
  initialize,
  initiateIdentityValidation,
  pushEvents,
  unbindAppInstance
});

export default window;
export { handleGlobalsReady };
